import styled from 'styled-components'

import { Skeleton, Typography } from '@blade/ui-kit'
import { Numeric } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'

import type BigNumber from 'bignumber.js'

type PairMarketCapacityProps = {
  marketCap: BigNumber
}

export const PairMarketCapacity: React.FC<PairMarketCapacityProps> = ({
  marketCap,
}) => {
  const { t } = useTranslation()

  return (
    <Root>
      <Label>{t('common.mcap-short')}</Label>
      <Value>
        <Numeric
          currency="$"
          value={marketCap}
          preset="currency-amount-short"
        />
      </Value>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 2px;
  justify-items: end;
`

const Label = styled(Typography).attrs({
  variant: 'body4-regular',
  component: 'div',
})`
  color: var(--text-11);
  text-align: right;
  white-space: nowrap;
`

const Value = styled(Typography).attrs({
  variant: 'body4-bold',
  component: 'div',
})`
  color: var(--text-12);
  text-align: right;
`

export const PairMarketCapacitySkeleton = () => {
  return (
    <Root>
      <Skeleton width={20} height={16} paddingBlock={2} />
      <Skeleton width={50} height={15} paddingBlock={1} />
    </Root>
  )
}
